import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Wrench } from 'lucide-react';

const Maintenance = () => {
    const navigate = useNavigate();

    return (
        <div className="status_page">
            <div className="status_icon"><Wrench size="32" /></div>
            <span className="status_code">Under Maintenance</span>
            <h1>We'll be right back</h1>
            <p>This app is temporarily down for maintenance. Try again in a little while.</p>
        </div>
    )
}

export default Maintenance;
